import React, { useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import "./setting.css";

const General = () => {
  const [formData, setFormData] = useState({
    labID: "",
    labName: "",
    address: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    telephone: "",
    fax: "",
    email: "",
    website: "",
    timeZone: "",
    licenseNumber: "",
    shippingAddress: "",
    shippingAddressLine2: "",
    shippingCountry: "",
    shippingState: "",
    shippingCity: "",
    shippingZipCode: "",
    supportName: "",
    supportLink: "",
    supportContent: "",
    showShippingAddress: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const toggleShippingAddress = () => {
    setFormData((prevState) => ({
      ...prevState,
      showShippingAddress: !prevState.showShippingAddress,
    }));
  };

  return (
    <div style={{ padding: "3px", backgroundColor: "#ffffff", width: "100%" }}>
      <h3 className="form-section-title">Contact Details</h3>

      <div className="form-box">
        <div className="form-row">
          <label htmlFor="labID" className="form-label">
            Lab ID
          </label>
          <input
            type="text"
            id="labID"
            name="labID"
            value={formData.labID}
            onChange={handleChange}
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="labName" className="form-label">
            Lab Name
          </label>
          <input
            type="text"
            id="labName"
            name="labName"
            value={formData.labName}
            onChange={handleChange}
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="address" className="form-label">
            Address
          </label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="addressLine2" className="form-label">
            Address Line 2
          </label>
          <input
            type="text"
            id="addressLine2"
            name="addressLine2"
            value={formData.addressLine2}
            onChange={handleChange}
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="country" className="form-label">
            Country
          </label>
          <select
            id="country"
            name="country"
            value={formData.country}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Select Country</option>
            <option value="Pakistan">Pakistan</option>
            <option value="India">India</option>
            <option value="USA">USA</option>
          </select>
        </div>

        <div className="form-row">
          <label htmlFor="state" className="form-label">
            State/Province
          </label>
          <select
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Select State</option>
            <option value="Punjab">Punjab</option>
            <option value="Sindh">Sindh</option>
            <option value="KPK">KPK</option>
          </select>
        </div>

        <div className="form-row">
          <label htmlFor="city" className="form-label">
            City
          </label>
          <select
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Select City</option>
            <option value="Lahore">Lahore</option>
            <option value="Karachi">Karachi</option>
            <option value="Islamabad">Islamabad</option>
          </select>
        </div>

        <div className="form-row">
          <label htmlFor="zipCode" className="form-label">
            Zip / Postal Code
          </label>
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="telephone" className="form-label">
            Telephone
          </label>
          <input
            type="text"
            id="telephone"
            name="telephone"
            value={formData.telephone}
            onChange={handleChange}
            placeholder="Enter telephone number"
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="fax" className="form-label">
            Fax
          </label>
          <input
            type="text"
            id="fax"
            name="fax"
            value={formData.fax}
            onChange={handleChange}
            placeholder="Enter fax number"
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter email address"
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="website" className="form-label">
            Website
          </label>
          <input
            type="text"
            id="website"
            name="website"
            value={formData.website}
            onChange={handleChange}
            placeholder="Enter website URL"
            className="form-input"
          />
        </div>

        <div className="form-row">
          <label htmlFor="timeZone" className="form-label">
            Time Zone
          </label>
          <select
            id="timeZone"
            name="timeZone"
            value={formData.timeZone}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Select Time Zone</option>
            <option value="GMT+0">GMT+0</option>
            <option value="GMT+1">GMT+1</option>
            <option value="GMT+2">GMT+2</option>
          </select>
        </div>

        <div className="form-row">
          <label htmlFor="licenseNumber" className="form-label">
            License Number
          </label>
          <input
            type="text"
            id="licenseNumber"
            name="licenseNumber"
            value={formData.licenseNumber}
            onChange={handleChange}
            placeholder="Enter license number"
            className="form-input"
          />
        </div>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <button onClick={toggleShippingAddress} className="form-section-toggle">
          <h3>Shipping Address</h3>
        </button>

        {formData.showShippingAddress && (
          <div className="form-box">
            <p className="form-box-note">
              When defined, this address is used on sent documents and labels.
            </p>

            <div className="form-row">
              <label htmlFor="shippingAddress" className="form-label">
                Address
              </label>
              <input
                type="text"
                id="shippingAddress"
                name="shippingAddress"
                value={formData.shippingAddress}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-row">
              <label htmlFor="shippingAddressLine2" className="form-label">
                Address Line 2
              </label>
              <input
                type="text"
                id="shippingAddressLine2"
                name="shippingAddressLine2"
                value={formData.shippingAddressLine2}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-row">
              <label htmlFor="shippingCountry" className="form-label">
                Country
              </label>
              <select
                id="shippingCountry"
                name="shippingCountry"
                value={formData.shippingCountry}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select Country</option>
                <option value="Pakistan">Pakistan</option>
                <option value="India">India</option>
                <option value="USA">USA</option>
              </select>
            </div>

            <div className="form-row">
              <label htmlFor="shippingState" className="form-label">
                State/Province
              </label>
              <input
                type="text"
                id="shippingState"
                name="shippingState"
                value={formData.shippingState}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-row">
              <label htmlFor="shippingCity" className="form-label">
                City
              </label>
              <select
                id="shippingCity"
                name="shippingCity"
                value={formData.shippingCity}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select City</option>
                <option value="Lahore">Lahore</option>
                <option value="Karachi">Karachi</option>
                <option value="Islamabad">Islamabad</option>
              </select>
            </div>

            <div className="form-row">
              <label htmlFor="shippingZipCode" className="form-label">
                Zip / Postal Code
              </label>
              <input
                type="text"
                id="shippingZipCode"
                name="shippingZipCode"
                value={formData.shippingZipCode}
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>
        )}

        <h3 className="form-section-toggle">Support Details</h3>
        <div className="form-box">
          <div className="form-row">
            <label htmlFor="supportLink" className="form-label">
              Support Link
            </label>
            <input
              type="text"
              id="supportLink"
              name="supportLink"
              value={formData.supportLink}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-row">
            <label htmlFor="supportName" className="form-label">
              Support Name
            </label>
            <input
              type="text"
              id="supportName"
              name="supportName"
              value={formData.supportName}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-row">
            <label htmlFor="supportContent" className="form-label">
              Support Content
            </label>
            <input
              type="text"
              id="supportContent"
              name="supportContent"
              value={formData.supportContent}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>
        <br />

        <div>
          <button
            onClick={() => {
              // Add your save logic here
            }}
            className="form-save-btn"
          >
            <FaPencilAlt /> Save General Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default General;